const AREAS_PER_CITY = {
  madrid: [
    {
      id: 10,
      name: 'area.id_10'
    },
    {
      id: 13,
      name: 'area.id_13'
    },
    {
      id: 11,
      name: 'area.id_11'
    },
    {
      id: 7,
      name: 'area.id_7'
    },
    {
      id: 9,
      name: 'area.id_9'
    },
    {
      id: 12,
      name: 'area.id_12'
    },
    {
      id: 14,
      name: 'area.id_14'
    },
    {
      id: 2,
      name: 'area.id_2'
    },
    {
      id: 16,
      name: 'area.id_16'
    },
    {
      id: 15,
      name: 'area.id_15'
    },
    {
      id: 17,
      name: 'area.id_17'
    },
    {
      id: 18,
      name: 'area.id_18'
    },
    {
      id: 19,
      name: 'area.id_19'
    },
    {
      id: 1,
      name: 'area.id_1'
    },
    {
      id: 20,
      name: 'area.id_20'
    },
    {
      id: 8,
      name: 'area.id_8'
    },
    {
      id: 6,
      name: 'area.id_6'
    },
    {
      id: 21,
      name: 'area.id_21'
    },
    {
      id: 3,
      name: 'area.id_3'
    },
    {
      id: 5,
      name: 'area.id_5'
    },
    {
      id: 4,
      name: 'area.id_4'
    }
  ],
  brussels: [
    {
      id: 58,
      name: 'area.id_58'
    },
    {
      id: 63,
      name: 'area.id_63'
    },
    {
      id: 59,
      name: 'area.id_59'
    },
    {
      id: 55,
      name: 'area.id_55'
    },
    {
      id: 56,
      name: 'area.id_56'
    },
    {
      id: 67,
      name: 'area.id_67'
    },
    {
      id: 71,
      name: 'area.id_71'
    },
    {
      id: 70,
      name: 'area.id_70'
    },
    {
      id: 72,
      name: 'area.id_72'
    },
    {
      id: 73,
      name: 'area.id_73'
    },
    {
      id: 68,
      name: 'area.id_68'
    },
    {
      id: 60,
      name: 'area.id_60'
    },
    {
      id: 61,
      name: 'area.id_61'
    },
    {
      id: 64,
      name: 'area.id_64'
    },
    {
      id: 66,
      name: 'area.id_66'
    },
    {
      id: 57,
      name: 'area.id_57'
    },
    {
      id: 62,
      name: 'area.id_62'
    },
    {
      id: 65,
      name: 'area.id_65'
    },
    {
      id: 69,
      name: 'area.id_69'
    }
  ],
  dublin: [
    {
      id: 78,
      name: 'area.id_78'
    },
    {
      id: 76,
      name: 'area.id_76'
    },
    {
      id: 83,
      name: 'area.id_83'
    },
    {
      id: 92,
      name: 'area.id_92'
    },
    {
      id: 82,
      name: 'area.id_82'
    },
    {
      id: 91,
      name: 'area.id_91'
    },
    {
      id: 90,
      name: 'area.id_90'
    },
    {
      id: 84,
      name: 'area.id_84'
    },
    {
      id: 85,
      name: 'area.id_85'
    },
    {
      id: 80,
      name: 'area.id_80'
    },
    {
      id: 77,
      name: 'area.id_77'
    },
    {
      id: 96,
      name: 'area.id_96'
    },
    {
      id: 86,
      name: 'area.id_86'
    },
    {
      id: 74,
      name: 'area.id_74'
    },
    {
      id: 93,
      name: 'area.id_93'
    },
    {
      id: 79,
      name: 'area.id_79'
    },
    {
      id: 94,
      name: 'area.id_94'
    },
    {
      id: 81,
      name: 'area.id_81'
    },
    {
      id: 95,
      name: 'area.id_95'
    },
    {
      id: 87,
      name: 'area.id_87'
    },
    {
      id: 88,
      name: 'area.id_88'
    },
    {
      id: 89,
      name: 'area.id_89'
    }
  ],
  valencia: [
    {
      id: 101,
      name: 'area.id_101'
    },
    {
      id: 104,
      name: 'area.id_104'
    },
    {
      id: 102,
      name: 'area.id_102'
    },
    {
      id: 118,
      name: 'area.id_118'
    },
    {
      id: 110,
      name: 'area.id_110'
    },
    {
      id: 105,
      name: 'area.id_105'
    },
    {
      id: 100,
      name: 'area.id_100'
    },
    {
      id: 109,
      name: 'area.id_109'
    },
    {
      id: 108,
      name: 'area.id_108'
    },
    {
      id: 119,
      name: 'area.id_119'
    },
    {
      id: 123,
      name: 'area.id_123'
    },
    {
      id: 117,
      name: 'area.id_117'
    },
    {
      id: 106,
      name: 'area.id_106'
    },
    {
      id: 99,
      name: 'area.id_99'
    },
    {
      id: 115,
      name: 'area.id_115'
    },
    {
      id: 114,
      name: 'area.id_114'
    },
    {
      id: 113,
      name: 'area.id_113'
    },
    {
      id: 107,
      name: 'area.id_107'
    },
    {
      id: 112,
      name: 'area.id_112'
    },
    {
      id: 111,
      name: 'area.id_111'
    },
    {
      id: 122,
      name: 'area.id_122'
    },
    {
      id: 121,
      name: 'area.id_121'
    },
    {
      id: 120,
      name: 'area.id_120'
    }
  ]
};

export const getCityAreas = cityName => AREAS_PER_CITY[cityName] || [];

export default { getCityAreas };
